<template>
  <v-dialog
    v-model="dialog"
    scrollable
    width="380"
    persistent
  >
    <v-card
      flat
      tile
    >
      <v-toolbar
        dense
        light
        class="grey lighten-2"
      >
        <v-toolbar-title class="text-body-1 font-weight-bold">
          {{ $t('m.changePasswd') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          color=""
          @click="handleCancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-progress-linear
          :active="isLoading"
          :indeterminate="isLoading"
          absolute
          bottom
          color="deep-purple accent-4"
        />
      </v-toolbar>

      <v-container class="mt-6 mb-2">
        <v-card
          class="pl-2 pr-2"
          flat
          tile
        >
          <v-form
            fluid
            ref="form"
          >
            <v-text-field
              v-model="oldPassword"
              dense
              outlined
              :label="$t('m.oldPasswd')"
              :error-messages="oldPasswordErrors"
              :append-icon="oldPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
              :type="oldPasswordShow ? 'text' : 'password'"
              @click:append="oldPasswordShow = !oldPasswordShow"
              @input="$v.oldPassword.$touch()"
              @blur="$v.oldPassword.$touch()"
            />

            <v-text-field
              v-model="newPassword"
              dense
              outlined
              :label="$t('m.newPasswd')"
              :error-messages="newPasswordErrors"
              :append-icon="newPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
              :type="newPasswordShow ? 'text' : 'password'"
              @click:append="newPasswordShow = !newPasswordShow"
              @input="$v.newPassword.$touch()"
              @blur="$v.newPassword.$touch()"
            />

            <v-btn
              block
              class="mt-2"
              :disabled="isLoading"
              depressed
              color="success"
              @click="save"
            >
              {{ $t('m.submit') }}
            </v-btn>
          </v-form>
        </v-card>
      </v-container> <!-- end workspace -->
    </v-card>

    <v-snackbar
      v-model="snackbar"
      centered
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'PasswordEditDialog',
  mixins: [validationMixin],
  props: [
    'visible'
  ],
  data () {
    return {
      dialog: false,

      isLoading: false,
      oldPassword: '',
      oldPasswordShow: false,
      newPassword: '',
      newPasswordShow: '',

      btnDisabled: false,
      snackbar: false,
      snackbarText: null
    }
  },

  validations: {
    oldPassword: { required, minLength: minLength(6) },
    newPassword: { required, minLength: minLength(6) }
  },

  computed: {
    oldPasswordErrors () {
      const errors = []
      if (!this.$v.oldPassword.$dirty) return errors
      !this.$v.oldPassword.required && errors.push(this.$t('m.required'))
      !this.$v.oldPassword.minLength && errors.push(this.$t('m.passwordMinLength'))
      return errors
    },
    newPasswordErrors () {
      const errors = []
      if (!this.$v.newPassword.$dirty) return errors
      !this.$v.newPassword.required && errors.push(this.$t('m.required'))
      !this.$v.newPassword.minLength && errors.push(this.$t('m.passwordMinLength'))
      return errors
    }
  },
  watch: {
    visible: function (val) {
      this.dialog = val
    }
  },
  created () {

  },
  methods: {
    handleCancel () {
      this.dialog = false
      this.clear()
      this.$emit('cancel')
    },

    save () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.isLoading = true
      var json = { }

      json.OperID = Utils.getWithExpiry('operID')
      json.OperOldPassword = this.oldPassword
      json.OperNewPassword = this.newPassword

      httpClient.post('/OPOperModPwd', json)
        .then((res) => {
          this.isLoading = false
          if (res.data.error) {
            this.snackbarText = this.$t('m.crrntPsswrdIncrrct')
            this.snackbar = true
          } else { //
            this.clear()
            this.$emit('save')
          }
        }).catch((err) => {
          this.isLoading = false
        })
    },

    clear () {
      this.$v.$reset()
      this.oldPassword = ''
      this.oldPasswordShow = false
      this.newPassword = null
      this.newPasswordShow = false
    }

  }
}
</script>

<style scoped lang="scss">
  .my-container {
    height: calc(100vh - 48px);
    overflow-y: auto;
  }
  .my-panel-content {
    margin: 0 -24px !important;
  }

</style>
